import { takeLatest, put, call } from 'redux-saga/effects'
import axios from 'axios'
import { getRequest } from '../../../../utils/User/axios'
import { getCategoryRequest, getCategorySuccess, getCategoryFailed } from '../Reducer'

export default function* getCategoryWatcherSage() {
  yield takeLatest(getCategoryRequest.type, getCategorySaga)
}

const getCategory = () => {
  getRequest(`${ process.env.REACT_APP_URL }/all-category`)
}

function fetch() {
  return axios({
    method: 'get',
    url: `${ process.env.REACT_APP_URL }/all-category`,
  })
}

function* getCategorySaga() {
  try {
    const response = yield call(fetch)
    yield put(getCategorySuccess(response.data))
  } catch (error) {
    yield put(getCategoryFailed(error))
  }
}
